import { createIcon } from "@chakra-ui/react";

/**
 * Showpass Logo in Primary colors
 * Colors are hard-coded to assure logo placement follows brand guidelines.
 */
const ShowpassLogo = createIcon({
  displayName: "ShowpassLogo",
  viewBox: "0 0 1472 339.6",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M76,232.3c9.1,0,15.6-0.9,19.3-2.7c3.8-1.8,5.7-5.2,5.7-10.3c0-4-2.4-7.5-7.3-10.5
				c-4.9-3-12.3-6.4-22.3-10.2c-7.8-2.9-14.8-5.9-21.2-9c-6.3-3.1-11.7-6.8-16.2-11.2c-4.5-4.3-7.9-9.5-10.3-15.5
				c-2.4-6-3.7-13.2-3.7-21.7c0-16.5,6.1-29.5,18.3-39c12.2-9.6,29-14.3,50.4-14.3c10.7,0,20.9,0.9,30.7,2.8
				c9.8,1.9,17.6,4,23.4,6.2l-8.7,38.7c-5.8-2-12.1-3.8-18.8-5.3c-6.8-1.6-14.4-2.3-22.9-2.3c-15.6,0-23.4,4.3-23.4,13
				c0,2,0.3,3.8,1,5.3c0.7,1.6,2,3.1,4,4.5c2,1.4,4.7,3,8.2,4.7c3.4,1.7,7.8,3.5,13.2,5.5c10.9,4,19.9,8,27,11.9
				c7.1,3.9,12.7,8.2,16.8,12.7c4.1,4.5,7,9.6,8.7,15.1c1.7,5.5,2.5,12,2.5,19.3c0,17.3-6.5,30.4-19.5,39.3
				c-13,8.9-31.4,13.3-55.2,13.3c-15.6,0-28.5-1.3-38.9-4c-10.3-2.7-17.5-4.9-21.5-6.7l8.3-40.4c8.4,3.3,17.1,6,26,7.8
				C58.5,231.4,67.3,232.3,76,232.3z"
      />
      <path
        fill="currentColor"
        d="M187.4,268V17.2l49.7-8v84.1c3.3-1.1,7.6-2.2,12.8-3.2c5.2-1,10.3-1.5,15.2-1.5c14.2,0,26.1,1.9,35.5,5.8
				c9.4,3.9,17,9.4,22.7,16.5c5.7,7.1,9.7,15.6,12,25.4c2.3,9.8,3.5,20.7,3.5,32.7V268h-49.7v-93.1c0-16-2.1-27.4-6.2-34
				c-4.1-6.7-11.7-10-22.8-10c-4.5,0-8.6,0.4-12.5,1.2c-3.9,0.8-7.4,1.6-10.5,2.5V268H187.4z"
      />
      <path
        fill="currentColor"
        d="M548,179.9c0,13.8-2,26.4-6,37.9c-4,11.5-9.8,21.2-17.3,29.4c-7.6,8.1-16.6,14.4-27.2,18.8
				c-10.6,4.4-22.4,6.7-35.5,6.7c-12.9,0-24.6-2.2-35.2-6.7c-10.6-4.4-19.6-10.7-27.2-18.8c-7.6-8.1-13.5-17.9-17.7-29.4
				c-4.2-11.5-6.3-24.1-6.3-37.9c0-13.8,2.2-26.4,6.5-37.7c4.3-11.3,10.3-21,18-29c7.7-8,16.8-14.2,27.4-18.7
				c10.6-4.4,22.1-6.7,34.5-6.7c12.7,0,24.3,2.2,34.9,6.7c10.6,4.5,19.6,10.7,27.2,18.7c7.6,8,13.5,17.7,17.7,29
				C545.9,153.6,548,166.2,548,179.9z M497.3,179.9c0-15.3-3.1-27.4-9.2-36.2c-6.1-8.8-14.8-13.2-26.2-13.2
				c-11.3,0-20.1,4.4-26.4,13.2c-6.2,8.8-9.3,20.8-9.3,36.2c0,15.3,3.1,27.5,9.3,36.5c6.2,9,15,13.5,26.4,13.5
				c11.3,0,20.1-4.5,26.2-13.5C494.2,207.5,497.3,195.3,497.3,179.9z"
      />
      <path
        fill="currentColor"
        d="M689.3,167.3c-4.5,16.9-9.2,33.7-14.2,50.4c-5,16.7-10.3,33.5-15.8,50.4h-38.7c-4-9.3-8.4-20.5-13-33.4
				c-4.7-12.9-9.5-27-14.6-42.2c-5-15.2-10.1-31.4-15.4-48.4c-5.2-17-10.3-34.2-15.2-51.5h52.4c1.8,8,3.7,16.7,5.9,26.2
				c2.1,9.5,4.4,19.2,6.7,29.2c2.4,10,4.8,20.1,7.4,30.2c2.6,10.1,5.2,19.8,7.9,29.2c2.9-9.8,5.7-19.8,8.5-30
				c2.8-10.2,5.4-20.3,8-30.2c2.6-9.9,5-19.5,7.3-28.7c2.3-9.2,4.4-17.8,6.2-25.9h36c1.8,8,3.8,16.6,6,25.9c2.2,9.2,4.6,18.8,7,28.7
				c2.4,9.9,5,20,7.7,30.2c2.7,10.2,5.4,20.2,8.3,30c2.7-9.3,5.4-19.1,8.1-29.2c2.7-10.1,5.2-20.2,7.6-30.2
				c2.3-10,4.6-19.7,6.7-29.2c2.1-9.4,4.1-18.2,5.9-26.2h51.7c-4.9,17.3-10,34.5-15.2,51.5c-5.2,17-10.4,33.1-15.4,48.4
				c-5,15.2-9.9,29.3-14.7,42.2c-4.8,12.9-9.2,24-13.2,33.4h-38.7c-5.6-16.9-11-33.7-16.3-50.4C698.6,201,693.7,184.2,689.3,167.3z"
      />
      <path
        fill="currentColor"
        d="M870.9,329.7h-21.7V101.6c6.4-2.2,14.7-4.3,24.7-6.3c10-2,22.7-3,38-3c12.7,0,24.2,2.1,34.5,6.2
				c10.3,4.1,19.2,10.1,26.7,17.8c7.4,7.8,13.2,17.2,17.3,28.4c4.1,11.1,6.2,23.7,6.2,37.7c0,13.1-1.7,25.2-5.2,36.2
				c-3.5,11-8.5,20.5-15.2,28.4c-6.7,7.9-14.8,14.1-24.5,18.5c-9.7,4.4-20.7,6.7-33.2,6.7c-11.3,0-21.2-1.6-29.5-4.8
				c-8.3-3.2-14.4-6.3-18.2-9.2V329.7z M870.9,237c2,1.6,4.5,3.2,7.5,5c3,1.8,6.5,3.5,10.5,5c4,1.6,8.3,2.8,13,3.8
				c4.7,1,9.6,1.5,14.7,1.5c10.7,0,19.6-1.8,26.9-5.5c7.2-3.7,13.1-8.7,17.5-15c4.4-6.3,7.7-13.8,9.7-22.3c2-8.6,3-17.6,3-27.2
				c0-22.7-5.7-40.1-17-52.2c-11.3-12.1-26.4-18.2-45-18.2c-10.7,0-19.3,0.5-25.9,1.5c-6.6,1-11.5,2.1-14.8,3.2V237z"
      />
      <path
        fill="currentColor"
        d="M1096.1,91.6c11.3,0,21,1.6,28.9,4.8c7.9,3.2,14.3,7.7,19.2,13.3c4.9,5.7,8.4,12.4,10.7,20.2
				c2.2,7.8,3.3,16.2,3.3,25.4V264c-2.2,0.7-5.5,1.4-9.7,2.2c-4.2,0.8-9.1,1.6-14.7,2.5c-5.6,0.9-11.7,1.6-18.5,2.2
				c-6.8,0.6-13.7,0.8-20.8,0.8c-9.1,0-17.5-1-25.2-3c-7.7-2-14.3-5.2-20-9.5c-5.7-4.3-10.1-9.9-13.3-16.7
				c-3.2-6.8-4.8-15.1-4.8-24.9c0-9.3,1.8-17.3,5.3-24c3.6-6.7,8.6-12.2,15-16.5c6.4-4.3,14.1-7.5,23-9.5c8.9-2,18.6-3,29-3
				c3.1,0,6.4,0.2,9.8,0.5c3.4,0.3,6.8,0.8,10,1.3c3.2,0.6,6,1.1,8.3,1.7c2.3,0.6,3.9,1.1,4.8,1.5v-10.7c0-6-0.4-11.8-1.3-17.5
				c-0.9-5.7-2.8-10.8-5.8-15.3c-3-4.6-7.2-8.2-12.7-11c-5.5-2.8-12.6-4.2-21.5-4.2c-12.7,0-22.1,0.9-28.4,2.7
				c-6.2,1.8-10.8,3.2-13.7,4.3l-3-19c3.8-1.8,9.6-3.4,17.5-5C1075.4,92.3,1084.9,91.6,1096.1,91.6z M1098.1,252.3
				c8.4,0,15.8-0.3,22.2-0.8c6.3-0.6,11.7-1.3,16.2-2.2v-60.7c-2.4-1.1-6.3-2.3-11.7-3.5c-5.3-1.2-12.7-1.8-22-1.8
				c-5.3,0-10.9,0.4-16.7,1.2c-5.8,0.8-11.1,2.4-16,5c-4.9,2.6-8.9,6.1-12,10.5c-3.1,4.5-4.7,10.3-4.7,17.7c0,6.5,1.1,11.9,3.2,16.3
				c2.1,4.5,5.1,8,9,10.7c3.9,2.7,8.6,4.6,14,5.8C1085,251.7,1091.2,252.3,1098.1,252.3z"
      />
      <path
        fill="currentColor"
        d="M1248.8,252.7c12.5,0,22.7-2.1,30.9-6.2c8.1-4.1,12.2-11.1,12.2-20.8c0-4.7-0.7-8.7-2.2-12
				c-1.4-3.3-3.8-6.3-7.2-9c-3.3-2.7-7.7-5.2-13.2-7.7c-5.5-2.4-12.2-5.3-20.2-8.7c-6.5-2.7-12.6-5.4-18.3-8.2
				c-5.8-2.8-10.9-6-15.3-9.7c-4.5-3.7-8-8.1-10.7-13.2c-2.7-5.1-4-11.3-4-18.7c0-14,5.3-25.4,15.8-34c10.6-8.7,25.1-13,43.5-13
				c11.8,0,21.5,1,29.2,3c7.7,2,13.1,3.8,16.2,5.3l-5,19.3c-2.7-1.3-7.2-3.1-13.5-5.3c-6.3-2.2-15.6-3.3-27.9-3.3
				c-4.9,0-9.5,0.5-13.8,1.5c-4.3,1-8.2,2.6-11.5,4.7c-3.3,2.1-6,4.8-8,8c-2,3.2-3,7.2-3,11.9c0,4.7,0.9,8.7,2.7,12
				c1.8,3.3,4.4,6.3,7.8,8.9c3.4,2.6,7.7,5,12.7,7.2c5,2.2,10.7,4.6,17.2,7.3c6.7,2.7,13.1,5.4,19.2,8.1c6.1,2.8,11.5,6.1,16.2,10
				c4.7,3.9,8.4,8.6,11.3,14c2.9,5.5,4.3,12.3,4.3,20.5c0,15.6-5.8,27.4-17.5,35.4c-11.7,8-27.6,12-47.9,12
				c-15.1,0-26.7-1.3-34.7-3.8c-8-2.6-13.3-4.5-16-5.8l5.7-19.7c0.7,0.4,2.1,1.2,4.3,2.2c2.2,1,5.2,2.1,9,3.3
				c3.8,1.2,8.3,2.3,13.5,3.2C1235.9,252.2,1242,252.7,1248.8,252.7z"
      />
      <path
        fill="currentColor"
        d="M1391.6,252.7c12.5,0,22.7-2.1,30.9-6.2c8.1-4.1,12.2-11.1,12.2-20.8c0-4.7-0.7-8.7-2.2-12
				c-1.4-3.3-3.8-6.3-7.2-9c-3.3-2.7-7.7-5.2-13.2-7.7c-5.5-2.4-12.2-5.3-20.2-8.7c-6.5-2.7-12.6-5.4-18.3-8.2
				c-5.8-2.8-10.9-6-15.3-9.7c-4.5-3.7-8-8.1-10.7-13.2c-2.7-5.1-4-11.3-4-18.7c0-14,5.3-25.4,15.8-34c10.6-8.7,25.1-13,43.5-13
				c11.8,0,21.5,1,29.2,3c7.7,2,13.1,3.8,16.2,5.3l-5,19.3c-2.7-1.3-7.2-3.1-13.5-5.3c-6.3-2.2-15.6-3.3-27.9-3.3
				c-4.9,0-9.5,0.5-13.8,1.5c-4.3,1-8.2,2.6-11.5,4.7c-3.3,2.1-6,4.8-8,8c-2,3.2-3,7.2-3,11.9c0,4.7,0.9,8.7,2.7,12
				c1.8,3.3,4.4,6.3,7.8,8.9c3.4,2.6,7.7,5,12.7,7.2c5,2.2,10.7,4.6,17.2,7.3c6.7,2.7,13.1,5.4,19.2,8.1c6.1,2.8,11.5,6.1,16.2,10
				c4.7,3.9,8.4,8.6,11.3,14c2.9,5.5,4.3,12.3,4.3,20.5c0,15.6-5.8,27.4-17.5,35.4c-11.7,8-27.6,12-47.9,12
				c-15.1,0-26.7-1.3-34.7-3.8s-13.3-4.5-16-5.8l5.7-19.7c0.7,0.4,2.1,1.2,4.3,2.2c2.2,1,5.2,2.1,9,3.3c3.8,1.2,8.3,2.3,13.5,3.2
				C1378.7,252.2,1384.7,252.7,1391.6,252.7z"
      />
    </g>
  ),
});

export default ShowpassLogo;
